import * as Sentry from '@sentry/react'
import { Location } from 'react-router-dom'

import authFetch from './authFetch'

export interface AuthCallbackRequest {
  code: string
  state: string
}

interface RedirectResponse {
  redirectUrl: string
}

export const parseQueryParams = (search: string): AuthCallbackRequest => {
  const params = new URLSearchParams(search)
  return {
    code: params.get('code') || '',
    state: params.get('state') || '',
  }
}

export const redirect = async () => {
  return await (authFetch.get('redirect', {
    isCallback: true,
  }) as Promise<RedirectResponse>)
}

const processIdPCallback = async (location: Location) => {
  const queryParams = parseQueryParams(location.search)
  try {
    await authFetch.get('callback', {
      params: queryParams,
      isCallback: true,
    })
    const { redirectUrl } = await redirect()
    window.location.href = redirectUrl
  } catch (error) {
    Sentry.captureException(error)
  }
}

export default processIdPCallback
